import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=3b06c1c2&scoped=true&"
import script from "./printer.vue?vue&type=script&lang=js&"
export * from "./printer.vue?vue&type=script&lang=js&"
import style0 from "./printer.vue?vue&type=style&index=0&id=3b06c1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b06c1c2",
  null
  
)

export default component.exports